import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export function useGetLookbook(id, enabled) {
  // A new lookbook has nothing to fetch, but "new" and a real id are the same
  // route param — so the old early return above the query changed the hook
  // count whenever the page went from one to the other without remounting.
  const isNew = id === "new";

  const query = useQuery({
    queryKey: ["lookbook", id],
    queryFn: async () => {
      const response = await axios.get(`/api/lookbooks/${id}`);

      return response.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: enabled && !isNew,
  });

  if (isNew) {
    return {
      lookbook: null,
      isLoading: false,
      isError: false,
    };
  }

  return {
    lookbook: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}

export function useUpsertLookbookApi() {
  const queryClient = useQueryClient();

  const query = useMutation({
    mutationFn: async ({ id, data }) => {
      const response = await (id !== "new"
        ? axios.put(`/api/lookbooks/${id}`, data)
        : axios.post("/api/lookbooks", data));

      return response.data;
    },
    onSuccess: (data, { id }) => {
      if (id === "new") {
        queryClient.setQueryData(["lookbook", data.lookbook.id], data);
      }

      queryClient.invalidateQueries({
        queryKey: ["lookbook", id],
        refetchType: "all",
      });
    },
  });

  return {
    upsertLookbook: query.mutateAsync,
    status: query.status,
    error: query.error,
  };
}
